import { Suspense } from 'react';

import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';

import themes from 'styles/themes';

import App from './App';
import reportWebVitals from './reportWebVitals';

import 'react-datepicker/dist/react-datepicker.css';
import 'reflect-metadata';
import 'requestidlecallback-polyfill';
import 'i18n';

import 'utils/date';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find the root element');
}

const root = createRoot(container);

root.render(
  <ThemeProvider theme={themes.main}>
    <Suspense fallback={<></>}>
      <App />
    </Suspense>
  </ThemeProvider>,
);

reportWebVitals();
